import React, { useEffect, useLayoutEffect, useRef, useState } from "react";

const CFG = {
  USD: { symbol: "$", group: ",", dec: ".", decimals: 4 },
  IDR: { symbol: "Rp", group: ".", dec: ",", decimals: 0 },
};

// Normalised raw string ("1234.5" | "") → display string with grouping.
function format(raw, c) {
  if (raw === "" || raw == null) return "";
  const [int, frac] = String(raw).split(".");
  const g = (int || "0").replace(/^0+(?=\d)/, "").replace(/\B(?=(\d{3})+(?!\d))/g, c.group);
  return frac !== undefined ? `${g}${c.dec}${frac}` : g;
}

// Display string typed by the user → normalised raw string.
function parse(text, c, decimals) {
  let s = "";
  let seenDec = false;
  for (const ch of text) {
    if (/\d/.test(ch)) s += ch;
    else if (decimals > 0 && !seenDec && ch === c.dec) { s += "."; seenDec = true; }
  }
  if (seenDec) { const [i, f] = s.split("."); s = `${i || "0"}.${f.slice(0, decimals)}`; }
  return s;
}

const sig = (str, end, c) => str.slice(0, end).split("").filter((ch) => /\d/.test(ch) || ch === c.dec).length;

export function MoneyInput({ value, onValue, currency = "USD", decimals, className = "", testid, disabled, placeholder, ...rest }) {
  const c = CFG[currency];
  const d = decimals ?? c.decimals;
  const ref = useRef(null);
  const caret = useRef(null);
  const ext = value === null || value === undefined || value === "" || Number.isNaN(Number(value)) ? "" : String(+Number(value).toFixed(d));
  const [raw, setRaw] = useState(ext);
  // keep partially typed text ("1.", "1.50") unless the parent value really changed
  useEffect(() => { setRaw((r) => (r === "" ? ext === "" : Number(r) === Number(ext)) ? r : ext); }, [ext]);
  const shown = format(raw, c);

  useLayoutEffect(() => {
    const el = ref.current;
    if (caret.current == null || !el || document.activeElement !== el) return;
    let n = caret.current, pos = 0;
    while (pos < shown.length && n > 0) { if (/\d/.test(shown[pos]) || shown[pos] === c.dec) n -= 1; pos += 1; }
    el.setSelectionRange(pos, pos);
    caret.current = null;
  });

  const onChange = (e) => {
    caret.current = sig(e.target.value, e.target.selectionStart ?? e.target.value.length, c);
    const next = parse(e.target.value, c, d);
    setRaw(next); onValue(next);
  };

  return (
    <span className={`relative flex items-center ${className}`}>
      <span className="pointer-events-none absolute left-2.5 text-xs font-semibold text-slate-400">{c.symbol}</span>
      <input ref={ref} type="text" inputMode={d > 0 ? "decimal" : "numeric"} disabled={disabled} placeholder={placeholder} value={shown} onChange={onChange}
        data-testid={testid} {...rest}
        className={`w-full rounded-lg border border-line bg-white py-1.5 pr-2 text-sm tabular-nums text-slate-900 outline-none transition-colors focus:border-brand disabled:bg-slate-50 disabled:text-slate-500 ${currency === "IDR" ? "pl-9" : "pl-6"}`} />
    </span>
  );
}

